import { createContext, useContext, useEffect, useState, useCallback } from "react";
import api from "@/lib/api";
import { useAuth } from "@/context/AuthContext";

const SubCtx = createContext(null);

export function SubscriptionProvider({ children }) {
  const { user } = useAuth();
  const [sub, setSub] = useState(null);
  const [loading, setLoading] = useState(true);

  const refresh = useCallback(async () => {
    if (!user) {
      setSub(null);
      setLoading(false);
      return;
    }
    try {
      const { data } = await api.get("/subscription/me");
      setSub(data);
    } catch (_e) {
      void _e;
    } finally {
      setLoading(false);
    }
  }, [user]);

  useEffect(() => {
    refresh();
  }, [refresh]);

  // Refresh every 60s in case the admin manually extends from another device
  useEffect(() => {
    if (!user) return undefined;
    const id = setInterval(refresh, 60_000);
    return () => clearInterval(id);
  }, [user, refresh]);

  return (
    <SubCtx.Provider value={{ sub, loading, refresh }}>
      {children}
    </SubCtx.Provider>
  );
}

export const useSubscription = () => useContext(SubCtx);
